import { render, staticRenderFns } from "./OrganizationsMoreDropdown.vue?vue&type=template&id=7ba8e3a4"
import script from "./OrganizationsMoreDropdown.vue?vue&type=script&lang=js"
export * from "./OrganizationsMoreDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports